﻿import { GuiAuswertung } from "./GuiAuswertung";
import { Chart } from "../chart-setup";
import { IChartData } from "../Interface/IChartData"

export class GuiAuswertungGewerbeabfallverordnung extends GuiAuswertung {
        chart?: Chart;

        constructor() {
            super("Gewerbeabfallverordnung");
        }

        draw() {

            const ctx = document.getElementById("chart") as HTMLCanvasElement;
            if (this.chart != undefined) {
                this.chart.destroy();
            }

            const jsonData = (document.getElementById("jsonChartData") as HTMLInputElement).value;
            if (jsonData == undefined || jsonData === "null") { return; }

            const barData = JSON.parse(jsonData) as IChartData;
            const data = {
                labels: barData.labels,
                datasets: [{
                    label: "",
                    data: barData.values,
                    backgroundColor: barData.colors,
                    hoverOffset: 4
                }]
            };

            this.chart = new Chart(ctx, this.CreateDoughnutConfig(data, barData.valuesArePercent));
        }


    }
